import { makeObservable, observable, computed } from "mobx"

class Chronometre {
  constructor() {
      this.startTime = 0;
      this.elapsedTime = 0;
      this.isRunning = false;
      this.interval = null;

      makeObservable(this, {
        elapsedTime: observable,
        elapsedTimeObj: computed
      })
  }

  start() {
      if (!this.isRunning) {
          this.startTime = Date.now() - this.elapsedTime;
          this.isRunning = true;
          this.interval = setInterval(() => {
              this.elapsedTime = Date.now() - this.startTime;
          }, 1000);
      }
  }

  pause() {
      if (this.isRunning) {
          clearInterval(this.interval);
          this.isRunning = false;
      }
  }

  reset() {
      clearInterval(this.interval);
      this.elapsedTime = 0;
      this.isRunning = false;
  }

  get elapsedTimeObj() {
    const totalSeconds = Math.floor(this.elapsedTime / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);

    return {
        minutes: totalMinutes,
        seconds: totalSeconds % 60
    }

  }
}

export default new Chronometre()